import rivets from 'rivets';
import BaseView from '../../core/baseView';

export default BaseView.extend({

    events: {
        'change [name="payment[creditcard_select]"]': 'onCreditCardChange'
    },

    selectors: {
        creditCardRadios: '[name="payment[creditcard_select]"]'
    },

    initialize: function () {
        /*
         Bind rivets
         */
        this.binding = rivets.bind(this.el, {
            model: this.model
        });

        /*
         Handle initial state
         */
        this.updatePaymentModelFromView();
    },

    onCreditCardChange: function () {
        this.updatePaymentModelFromView();
    },

    updatePaymentModelFromView: function () {
        var $currentRadio = this.$(this.selectors.creditCardRadios).filter(':checked');
        var cardId;
        var currentCreditCardType;

        if ($currentRadio.length > 0) {
            cardId = parseInt($currentRadio.val(), 10);

            if (cardId > 0) {
                currentCreditCardType = $currentRadio.data('type');
            } else {
                currentCreditCardType = null;
            }
        } else {
            cardId = 0;
        }

        this.model.set({
            creditCard: cardId,
            currentCreditCardType: currentCreditCardType
        });
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/checkout/paymentCreditCardView.js
 **/